import { monteurApi } from '../common/monteur-api';
export var clientsApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: [
        'Client',
        'Clients',
        'ClientsList',
        'MachineClients',
        'PaginatedClients',
        'ClientsLocations'
    ]
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        getAllClients: builder.query({
            query: function (query) { return ({
                url: "Client/get-all",
                method: 'POST',
                body: query
            }); },
            providesTags: ['AllClients']
        }),
        getClientsList: builder.query({
            query: function () { return "Client/get-list"; },
            providesTags: ['Clients']
        }),
        getAllClientsByCompany: builder.query({
            query: function (companyId) { return "Client/get-all-by-company?companyId=".concat(companyId); },
            providesTags: ['Clients']
        }),
        getAllClientsByMachine: builder.query({
            query: function (machineId) { return "Client/get-all-by-machine?machineId=".concat(machineId); },
            providesTags: ['MachineClients']
        }),
        updateClientStatus: builder.mutation({
            query: function (client) { return ({
                url: 'Client/update-status',
                method: 'POST',
                body: client
            }); },
            invalidatesTags: [
                'Clients',
                'AllClients',
                'ClientsList',
                'PaginatedClients',
                'ClientsLocations'
            ]
        }),
        createClient: builder.mutation({
            query: function (client) { return ({
                url: 'Client/create',
                method: 'POST',
                body: client
            }); },
            invalidatesTags: [
                'Clients',
                'AllClients',
                'ClientsList',
                'PaginatedClients',
                'ClientsLocations'
            ]
        }),
        updateClient: builder.mutation({
            query: function (client) { return ({
                url: 'Client/update',
                method: 'POST',
                body: client
            }); },
            invalidatesTags: [
                'Clients',
                'AllClients',
                'ClientsList',
                'PaginatedClients',
                'ClientsLocations'
            ]
        }),
        getClient: builder.query({
            query: function (id) { return ({
                url: "Client/get-by-id?id=".concat(id)
            }); },
            providesTags: ['Client']
        }),
        deleteClient: builder.mutation({
            query: function (id) { return ({
                url: "Client/delete?id=".concat(id),
                method: 'DELETE'
            }); },
            invalidatesTags: [
                'Client',
                'Clients',
                'AllClients',
                'ClientsList',
                'PaginatedClients',
                'ClientsLocations'
            ]
        }),
        getListByName: builder.query({
            query: function (query) { return "Client/get-list-by-name?name=".concat(query); },
            providesTags: ['ClientsList']
        }),
        getPaginatedClients: builder.query({
            query: function (query) { return ({
                url: 'Client/get-paginated',
                method: 'POST',
                body: query
            }); },
            providesTags: ['PaginatedClients']
        }),
        getClientsLocationList: builder.query({
            query: function (query) { return ({
                url: 'Client/get-location-list',
                method: 'POST',
                body: query
            }); },
            providesTags: ['ClientsLocations']
        })
    }); }
});
export var useGetAllClientsQuery = clientsApi.useGetAllClientsQuery, useGetClientsListQuery = clientsApi.useGetClientsListQuery, useGetAllClientsByCompanyQuery = clientsApi.useGetAllClientsByCompanyQuery, useUpdateClientStatusMutation = clientsApi.useUpdateClientStatusMutation, useCreateClientMutation = clientsApi.useCreateClientMutation, useUpdateClientMutation = clientsApi.useUpdateClientMutation, useLazyGetClientQuery = clientsApi.useLazyGetClientQuery, useDeleteClientMutation = clientsApi.useDeleteClientMutation, useLazyGetListByNameQuery = clientsApi.useLazyGetListByNameQuery, useLazyGetAllClientsByMachineQuery = clientsApi.useLazyGetAllClientsByMachineQuery, useGetAllClientsByMachineQuery = clientsApi.useGetAllClientsByMachineQuery, useGetPaginatedClientsQuery = clientsApi.useGetPaginatedClientsQuery, useGetClientsLocationListQuery = clientsApi.useGetClientsLocationListQuery;
